// hooks/useInitData.ts
import { useQuery } from '@tanstack/react-query';
import { getAccessTokenFromLS } from '@martech-solution/utils/utils';
import { checkAdmin } from 'src/apis/master_data/user.api';
import { getUserResourceFullAccess } from 'src/apis/master_data/userResource.api';

function safeBase64Decode(str: string): string | null {
  try {
    // Thêm padding nếu thiếu
    const pad = str.length % 4;
    if (pad) str += '='.repeat(4 - pad);
    return atob(str.replace(/-/g, '+').replace(/_/g, '/'));
  } catch {
    return null;
  }
}

export function useInitData({ enabled = false }) {
  const token = getAccessTokenFromLS();

  let decodedToken = null;
  if (token) {
    const parts = token.split('.');
    if (parts.length === 3) {
      const payload = safeBase64Decode(parts[1]);
      if (payload) {
        decodedToken = JSON.parse(payload);
      }
    }
  }
  const role = (decodedToken?.role || '')?.toLowerCase();
  const isSupportUser = role === 'support';

  //   useQuery({
  //     queryKey: ['checkAdmin', token],
  //     queryFn: async () => await checkAdmin(),
  //     enabled: !!token && enabled,
  //     // onSuccess: (data: AxiosResponse<boolean, any>) => {
  //     //   if (data.data) {
  //     //     localStorage.setItem('isAdmin', JSON.stringify(data.data));
  //     //   }
  //     //   setIsUserAdmin(data.data);
  //     // }
  //   });

  //   useQuery({
  //     queryKey: ['webConfigs', token],
  //     queryFn: async () => await getWebConfigs(),
  //     staleTime: 60 * 1000,
  //     enabled: !!token && enabled,
  //     onSuccess: (data: AxiosResponse<WebConfigAdd[], any>) => {
  //       if (data?.data && data?.data.length > 0) {
  //         const result = Object.fromEntries(data?.data.map((item) => [item.key, item.value]));
  //         setTheme(result[WebConfigEn.theme] as Theme);
  //         setLanguage(result[WebConfigEn.language] as Language);
  //       }
  //     }
  //   });

  //   const { isFetching: resourcePermissionFetching } = useQuery({
  //     queryKey: ['userAccessResource', token],
  //     queryFn: async () => await getUserResourceFullAccess(),
  //     staleTime: 60 * 1000 * 10,
  //     enabled: !!token && enabled,
  //     onSuccess: (data: AxiosResponse<IUserResourceFullAccess, any>) => {
  //       // Set Resource
  //       let _resourcePermissions: IResourceFullAccessDetail[] = [];
  //       // Kiểm tra trùng path thì gộp quyền lại
  //       data.data?.details?.forEach(({ path, permissions, hrTicketCategoryCode, name }) => {
  //         if (!!path) {
  //           let pathRoots = path?.split(',');
  //           pathRoots?.forEach((pathString) => {
  //             const index = _resourcePermissions?.findIndex((x) => x.path === pathString);
  //             if (index === -1) {
  //               _resourcePermissions.push({ path: pathString, permissions: permissions, name, hrTicketCategoryCode });
  //             } else {
  //               _resourcePermissions[index] = {
  //                 path: pathString,
  //                 name,
  //                 hrTicketCategoryCode,
  //                 permissions: [...(_resourcePermissions[index] || [])?.permissions, ...permissions]
  //               };
  //             }
  //           });
  //         }
  //       });
  //       setResources(_resourcePermissions);

  //       // Set User Info
  //       if (data.data.employee) {
  //         setUserInfo(data.data.employee);
  //         localStorage.setItem('userInfo', JSON.stringify(data.data.employee));
  //       }
  //     }
  //   });

  const checkAdminQuery = useQuery({
    queryKey: ['checkAdmin', token, isSupportUser],
    queryFn: checkAdmin,
    enabled: !!token && !isSupportUser && enabled
  });

  //   const webConfigQuery = useQuery({
  //     queryKey: ['webConfigs', token, isSupportUser],
  //     queryFn: getWebConfigs,
  //     staleTime: 60 * 1000,
  //     enabled: !!token && !isSupportUser && enabled
  //   });

  const resourceQuery = useQuery({
    queryKey: ['userAccessResource', token, isSupportUser],
    queryFn: async () => await getUserResourceFullAccess(),
    staleTime: 60 * 1000 * 10,
    enabled: !!token && !isSupportUser && enabled
  });

  return {
    checkAdminQuery,
    // webConfigQuery,
    resourceQuery,
    isSupportUser
  };
}
